import i18n from "i18next";

export function columnsItemInvInvs() {
  return [
    {
      id: "description",
      label: i18n.t("column.description"),
      minWidth: 110,
      maxWidth: 150,
      align: "left",
    },
    {
      id: "code",
      label: i18n.t("column.code"),
      minWidth: 40,
      maxWidth: 80,
      align: "left",
    },
    {
      id: "vat",
      label: i18n.t("column.vat_rate"),
      minWidth: 35,
      maxWidth: 110,
      align: "left",
    },
  ];
}
